import PropTypes from 'prop-types';

export const Courses = PropTypes.arrayOf(PropTypes.shape({
  fullName: PropTypes.string,
  id: PropTypes.number,
  name: PropTypes.string,
}));
export const StaffTypes = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  position: PropTypes.number,
  shortName: PropTypes.string,
  tinyName: PropTypes.string,
}));
export const PlanGroup = PropTypes.shape({
  courses: Courses,
  dates: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.number,
  name: PropTypes.string,
  plans: PropTypes.arrayOf(PropTypes.string),
  published: PropTypes.bool,
  spreadsheet_author: PropTypes.string,
  spreadsheet_updated_at: PropTypes.string,
});
export const Mentors = PropTypes.arrayOf(PropTypes.shape({
  area: PropTypes.string,
  assignedPlanGroups: PropTypes.arrayOf(PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    id: PropTypes.number,
  })),
  attend: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    is_active: PropTypes.bool,
    symbol: PropTypes.string,
  })),
  campMentorId: PropTypes.number,
  comment: PropTypes.string,
  coursesPoints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    point: PropTypes.number,
  })),
  fullName: PropTypes.string,
  gender: PropTypes.string,
  id: PropTypes.number,
  nickname: PropTypes.string,
  season: PropTypes.string,
  trainingCourse: PropTypes.string,
  staffTypes: StaffTypes,
}));
export const Students = PropTypes.arrayOf(PropTypes.shape({
  assignedTeam: PropTypes.bool,
  attendCamp: PropTypes.string,
  attendSchool: PropTypes.string,
  courseName: PropTypes.string,
  days: PropTypes.number,
  fullName: PropTypes.string,
  gender: PropTypes.string,
  grade: PropTypes.string,
  groupingComment: PropTypes.string,
  id: PropTypes.number,
  schoolName: PropTypes.string,
  status: PropTypes.string,
  stay: PropTypes.string,
  studentStatusId: PropTypes.number,
  tech: PropTypes.bool,
  free_trial: PropTypes.string,
  joiningMonth: PropTypes.number,
}));
export const Team = PropTypes.shape({
  alphabet: PropTypes.string,
  courses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  id: PropTypes.number,
  memo: PropTypes.string,
  mentors: Mentors,
  staffTypes: StaffTypes,
  students: Students,
});
export const Teams = PropTypes.arrayOf(Team);
export const Prices = PropTypes.shape({
  price: PropTypes.number,
  priceBeforeTax: PropTypes.number,
  details: PropTypes.shape({
    basePrice: PropTypes.number,
    pcRentalFee: PropTypes.number,
    travelCost: PropTypes.number,
    rentalPrices: PropTypes.shape({
      totalPrice: PropTypes.number,
      rentals: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        price: PropTypes.number,
      })),
    }),
    paymentDiscount: PropTypes.number,
    couponDiscount: PropTypes.number,
    earlyDiscount: PropTypes.number,
    earlyDiscounts: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      amount: PropTypes.number,
    })),
    cancelFee: PropTypes.number,
    cancelRate: PropTypes.number,
  }),
  courponErrors: PropTypes.shape({
    error: PropTypes.string,
  }),
  tax: PropTypes.number,
});
export const CampEntry = PropTypes.shape({
  plan: PropTypes.string.isRequired,
  stayplan: PropTypes.string.isRequired,
  ai_rental_notice: PropTypes.string,
  pcRental: PropTypes.shape({
    isAllPcRental: PropTypes.bool,
    AvailableCampRentals: PropTypes.bool,
    campRentals: PropTypes.arrayOf(PropTypes.shape({
      camp_rental_id: PropTypes.number,
      created_at: PropTypes.string,
      id: PropTypes.number,
      pc_type_id: PropTypes.string,
      student_status_id: PropTypes.number,
      updated_at: PropTypes.string,
      use_rental: PropTypes.string,
    })),
    pcRentalDiscription: PropTypes.string,
    pcType: PropTypes.string,
    pcRental: PropTypes.bool,
    meeting_time: PropTypes.string,
    grouping_comment: PropTypes.string,
  }),
});

export const Student = PropTypes.shape({
  id: PropTypes.number,
  email: PropTypes.string,
  first_name: PropTypes.string,
  first_name_kana: PropTypes.string,
  last_name: PropTypes.string,
  last_name_kana: PropTypes.string,
  medicine: PropTypes.string,
  nickname: PropTypes.string,
  phone: PropTypes.string,
});

export const SchoolPrices = PropTypes.shape({
  entryOriginal: PropTypes.number,
  entryPrice: PropTypes.number,
  entryTax: PropTypes.number,
  couponDiscount: PropTypes.number,
  monthlyTotal: PropTypes.number,
  monthlyPrice: PropTypes.number,
  monthlyTax: PropTypes.number,
  fullMonthlyTotal: PropTypes.number,
  fullMonthlyTax: PropTypes.number,
  fullMonthlyPrice: PropTypes.number,
  fullPaymentTotal: PropTypes.number,
  fullPaymentTax: PropTypes.number,
  fullPaymentPrice: PropTypes.number,
});
